import React from "react"
import {
  Modal,
  Button,
} from "react-bootstrap"
import ProcessesStatus from "../fragments/ProcessesStatus"

export default function OrganizationActivity({ show, close, organization, activityError,
  activityRunning, doAction }) {

  return (
    <Modal show={ show } onHide={ close }>

      <Modal.Header closeButton>
        <Modal.Title>
          Mark the organization <strong>{ organization.name }</strong> as inactive.
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          This operation will mark this organization as inactive, therefore any authority 
          (Admin, Approver, etc.) will not be able to log in nor do any operation.
        </p>

        <ProcessesStatus
          error={ activityError }
          running={ activityRunning }
          success={ null }
        />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>Cancel</Button>
        <Button bsStyle="danger" onClick={ doAction }
          disabled={ !!(activityRunning || activityError) }>
          Mark as inactive
        </Button>
      </Modal.Footer>

    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationActivity.js